import { Outlet } from "react-router-dom";
import React, { useState, useEffect, useMemo, useRef } from "react";

import { AgGridReact } from "ag-grid-react"; // React Data Grid Component
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the Data Grid

export default function ProfilesPage() {
  const [rowData, setRowData] = useState([]);

  const CustomLinkedinCell = (props) => {
    var profileId = props.getValue();
    var linkedUrl = "https://linkedin.com/in/" + profileId + "/";
    return (
      <a href={linkedUrl} target="_new">
        {profileId}
      </a>
    );
  };

  const DateCell = (props) => {
    const dateValue = props.getValue();
    if (!dateValue) return "";
    const date = new Date(dateValue);
    return date.toLocaleString();
  };

  const InterestCell = (props) => {
    const interest = props.getValue();
    const profileId = props.data.profileId;

    const handleRemove = async () => {
      try {
        const response = await fetch(`/api/profilesIds/${profileId}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ interest: false }),
        });

        if (response.ok) {
          // Update the row data to reflect the change
          const updatedData = await response.json();
          setRowData((prevData) =>
            prevData.map((row) =>
              row.profileId === profileId ? { ...row, interest: false } : row
            )
          );
        }
      } catch (error) {
        console.error("Error updating interest:", error);
      }
    };

    return interest ? (
      <button
        onClick={handleRemove}
        className="px-2 py-1 text-sm bg-red-600 hover:bg-red-700 text-white rounded"
      >
        Remove
      </button>
    ) : (
      ""
    );
  };

  const [colDefs, setColDefs] = useState([
    {
      field: "profileId",
      headerName: "Profile ID",
      cellRenderer: CustomLinkedinCell,
      width: 250,
    },
    {
      field: "counter",
      headerName: "Counter",
      sort: "desc",
      width: 120,
    },
    {
      field: "interest",
      headerName: "Interest",
      cellRenderer: InterestCell,
      width: 100,
    },
    {
      field: "createdAt",
      headerName: "Created At",
      cellRenderer: DateCell,
      width: 200,
    },
    {
      field: "updatedAt",
      headerName: "Updated At",
      cellRenderer: DateCell,
      width: 200,
    },
  ]);

  useEffect(() => {
    // Fetch both profilesIds and profiles data
    Promise.all([
      fetch("/api/profilesIds", { redirect: "manual" }).then((response) =>
        response.json()
      ),
      fetch("/api/prospects/", { redirect: "manual" }).then((response) =>
        response.json()
      ),
    ]).then(([profilesIdsData, profilesData]) => {
      // Create a Set of linkedinIds from profiles for faster lookup
      const existingLinkedinIds = new Set(
        profilesData.map((profile) => profile.linkedinId)
      );

      // Filter out profileIds that exist in the profiles data
      const filteredData = profilesIdsData.filter(
        (profileId) => !existingLinkedinIds.has(profileId.profileId)
      );

      setRowData(filteredData);
    });
  }, []);

  return (
    <>
      <div
        className="ag-theme-quartz-dark" // applying the Data Grid theme
        style={{}} // the Data Grid will fill the size of the parent container
      >
        <AgGridReact rowData={rowData} columnDefs={colDefs} />
      </div>
    </>
  );
}
